"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ActionTypes = require("./actionTypes");
function default_1(namespace) {
    const _ActionTypes = ActionTypes.default(namespace);
    // FETCH
    function createRequest(folder, user) {
        return {
            type: _ActionTypes.CREATE_NEW_REQUEST,
            payload: {
                folder,
                data: Object.assign(Object.assign({}, user), { avatar: '' })
            }
        };
    }
    function createSuccess(folder, user) {
        return {
            type: _ActionTypes.CREATE_NEW_SUCCESS,
            payload: { folder, user }
        };
    }
    function createFailed(error) {
        return {
            type: _ActionTypes.CREATE_NEW_FAILED,
            payload: error
        };
    }
    function updateField(field, value) {
        return {
            type: _ActionTypes.UPDATE_FIELD,
            payload: {
                field,
                value
            }
        };
    }
    function clearState() {
        return {
            type: _ActionTypes.CLEAR
        };
    }
    function setModalStatus(status) {
        return {
            type: _ActionTypes.SET_MODAL_STATUS,
            payload: status
        };
    }
    function validateSuccess(user) {
        return {
            type: _ActionTypes.VALIDATE_NEW_SUCCESS,
            payload: user
        };
    }
    function validateFailure(errors) {
        return {
            type: _ActionTypes.VALIDATE_NEW_FAILURE,
            payload: errors
        };
    }
    return {
        createRequest,
        createSuccess,
        createFailed,
        updateField,
        clearState,
        setModalStatus,
        validateSuccess,
        validateFailure
    };
}
exports.default = default_1;
//# sourceMappingURL=actions.js.map